export default __webpack_public_path__ + "static/media/duitnow1.f5c31686.png";